import { fetchWithAuth } from "./fetch-with-auth";
import { API_URL } from "constants/index";

export type NotificationType = "success" | "error" | "neutral";

export interface NotificationItem {
  id: number;
  message: string;
  type: NotificationType;
  fileNames?: string[] | null;
  createdAt: string;
  readByUsers?: string[] | null;
  userId?: string | null;
  url?: string | null;
}

/** Fetches the notifications visible to a user (personal + broadcast). */
export async function fetchNotifications(
  userId: string,
  session: any,
): Promise<NotificationItem[]> {
  const res = await fetchWithAuth(
    `${API_URL}/notifications/get-notifications`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId }),
    },
    session,
  );
  if (!res.ok) throw new Error(`Kon meldingen niet ophalen (${res.status})`);
  return res.json();
}

/** Marks a single notification as read for the user. */
export async function markNotificationRead(
  id: number,
  userId: string,
  session: any,
): Promise<void> {
  const res = await fetchWithAuth(
    `${API_URL}/notifications/mark-as-read/${id}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId }),
    },
    session,
  );
  if (!res.ok) throw new Error(`Kon melding niet markeren (${res.status})`);
}

/** Marks every notification visible to the user (personal + broadcast) as read. */
export async function markAllNotificationsRead(
  userId: string,
  session: any,
): Promise<void> {
  const res = await fetchWithAuth(
    `${API_URL}/notifications/mark-all-as-read`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId }),
    },
    session,
  );
  if (!res.ok) throw new Error(`Kon meldingen niet markeren (${res.status})`);
}

/** True when the given notification has been read by the user. */
export function isRead(notification: NotificationItem, userId?: string): boolean {
  return !!userId && !!notification.readByUsers?.includes(userId);
}
